import { useCallback, useMemo } from 'react';

import Icon from 'components/Icon/Icon';
import Menu, { type MenuItem } from 'components/Menu';
import { useConfig } from 'config';
import { getMediaUrl } from 'utils/assets';
import { Translation } from 'utils/translations';

import styles from './NavigationMenu.module.scss';

const CONFIG_FALLBACK = {
  items: [],
};

const NavigationMenu = () => {
  const config = useConfig('config.siteConfig.menu') || CONFIG_FALLBACK;

  const menuItems = useMemo(
    () =>
      config.items.map(({ label, icon, location }, index) => ({
        id: `${index}`,
        label: <Translation message={label} />,
        icon: icon,
        link: location,
      })),
    [config.items],
  );

  const renderIcon = useCallback(
    ({ icon, link }: MenuItem) =>
      icon ? (
        <img
          src={getMediaUrl(icon, 'cms')}
          alt={link}
          className={styles.icon}
        />
      ) : (
        <Icon name="casino.bold" width={24} height={24} />
      ),
    [],
  );

  return (
    <Menu
      items={menuItems}
      renderIcon={renderIcon}
      className={styles['navigation-menu']}
      dataId="navigation-menu"
    />
  );
};

export default NavigationMenu;
